module.exports = __webpack_public_path__ + "static/assets/8b6dbeced2aabdb7501ad6df8cba1464.png";